import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { TextSizeToggle } from "@/components/layout/TextSizeToggle";
import { MobileMenu } from "@/components/layout/MobileMenu";
import { NAV, useNavGo } from "@/components/layout/nav";
import { useCart } from "@/context/CartContext";
import { useStoreConfig } from "@/hooks/useProducts";
import { formatShortEUR } from "@/lib/format";

export const Header = () => {
  const { count, setOpen } = useCart();
  const { threshold } = useStoreConfig();
  const go = useNavGo();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50">
      <div className="bg-navy text-ivory">
        <p className="container-pf py-2 text-center text-[12px] uppercase tracking-[0.22em] sm:text-[13px]" data-testid="announcement-bar">
          Spedizione gratuita da {formatShortEUR(threshold)} · Acquisto senza registrazione
        </p>
      </div>
      <div className={`border-b backdrop-blur-xl transition-[background-color,box-shadow,border-color] duration-500 ${scrolled ? "border-copper/25 bg-ivory/90 shadow-[0_12px_40px_-24px_rgba(15,30,51,0.35)]" : "border-transparent bg-ivory/75"}`}>
        <div className="container-pf flex h-20 items-center justify-between gap-6">
          <Link to="/" data-testid="header-logo-link" aria-label="Perfero, torna alla home">
            <Logo />
          </Link>
          <nav className="hidden items-center gap-10 lg:flex" aria-label="Navigazione principale">
            {NAV.map((item) => (
              <button key={item.id} type="button" onClick={() => go(item)} data-testid={`nav-${item.id}`} className="link-underline text-[15px] font-medium tracking-wide text-navy">
                {item.label}
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-2 sm:gap-4">
            <div className="hidden md:block">
              <TextSizeToggle />
            </div>
            <button
              type="button"
              onClick={() => setOpen(true)}
              data-testid="header-cart-button"
              aria-label={`Apri il carrello, ${count} articoli`}
              className="group relative flex h-12 items-center gap-2 rounded-full bg-navy pl-4 pr-3 text-ivory transition-colors duration-300 hover:bg-navy-700 sm:pl-5 sm:pr-4"
            >
              <ShoppingBag className="h-5 w-5" strokeWidth={1.6} />
              <span className="hidden text-[15px] font-medium sm:inline">Carrello</span>
              <span data-testid="cart-count-badge" className="grid h-7 min-w-7 place-items-center rounded-full bg-copper-light px-2 text-[13px] font-semibold text-navy">
                {count}
              </span>
            </button>
            <MobileMenu />
          </div>
        </div>
      </div>
    </header>
  );
};
